import { docTypesModel } from '../../models/keyValuePair';

export const encryptionKeys = {
  IV: '3t4p2bfatyhsoirp',
  key: '8g7y0f54hfde67rtv'
};

export const VERIFICATION_TYPE = {
  SIGNUP: 1,
  LOGIN: 2,
  UPDATE: 3,
  FORGET: 4
};

export const userRole = {
  Admin: 1,
  SubAdmin: 2
};

export const  statusTabs = {
  Pending: 1,
  Accepted: 2,
  Rejected: 3
};

export const docRole = {
  PACKAGE: 1,
  HOMESTAYS: 2,
  TICKETING: 3
};

export const rolesTypes: Array<docTypesModel> = [
  {
    name: 'PACKAGE',
    value: 1
  },
  {
    name: 'HOMESTAYS',
    value: 2
  },
  {
    name: 'TICKETING',
    value: 3
  }
];

export const couponTypes: Array<docTypesModel> = [
  {
    name: 'Flat',
    value: 2
  },
  {
    name: 'Percentage',
    value: 1
  }
];

export const revenueTabs = {
  Admin:0,
  ServiceProvider:1
};